<template>
    <div class="goodsClassification" v-loading="loadingNum">
        <div class="menuCont">
            <my-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultProps"
                :nodeKey="'id'"
                :defaultExpandedKeys="defaultExpandedKeys"
                @handleAddTreeNode="handleAddTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
                :btnName="btnName"
                treeSearchBar
                :draggable="false"
                @allowDrop="allowDrop"
            >
            </my-tree>
        </div>
        <div class="formCont">
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="100px"
                :inline="true"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="ID">
                            <el-input
                                disabled
                                placeholder="Plaese Input ID"
                                maxlength="50"
                                size="small"
                                v-model="addForm.id"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Name"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Plaese Input Name',
                                },
                            ]"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="Plaese Input Name"
                                maxlength="50"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Name_en"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Plaese Input Name_en',
                                },
                            ]"
                        >
                            <el-input
                                clearable
                                placeholder="Plaese Input Name_en"
                                maxlength="50"
                                size="small"
                                v-model="addForm.name_en"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Code">
                            <el-input
                                clearable
                                placeholder="Plaese Input Code"
                                maxlength="50"
                                size="small"
                                v-model="addForm.code"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Parent_name">
                            <el-cascader
                                filterable
                                clearable
                                :options="cascaderTreeData"
                                :props="props"
                                v-model="addForm.parent_id"
                                style="width: 100%"
                                placeholder="Plaese Select Parent_name"
                                size="small"
                                :show-all-levels="false"
                            >
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Sort"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Plaese Input Sort',
                                },
                            ]"
                            prop="sort"
                        >
                            <el-input
                                placeholder="Plaese Input Sort"
                                clearable
                                maxlength="50"
                                size="small"
                                v-model.number="addForm.sort"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
                style="text-align: left; margin: 80px 0 0 100px"
            >
                <el-button @click="commit" type="primary" size="small"
                    >Save</el-button
                >
                <el-button @click="clear" v-if="nowStatus" size="small"
                    >Empty</el-button
                >
                <el-button @click="del" type="danger" v-else size="small"
                    >Remove</el-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import Tree from "@/common/components/treeChange";
export default {
    data() {
        return {
            treeData: [],
            cascaderTreeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "cat_id",
                label: "name_en",
            },
            props: {
                value: "id",
                label: "name_en",
                children: "cat_id",
                checkStrictly: true,
            },
            addForm: {
                name: "",
                name_en: "",
                id: "",
                parent_id: "",
                sort: 0,
                code: "",
            },
            nowStatus: 0,
            nowClick: {},
            btnName: "Create Category",
            loadingNum: 0,
            defaultExpandedKeys: [],
        };
    },
    components: {
        "my-tree": Tree,
    },
    methods: {
        /**
         * 分类树
         */
        goodsCategory(id) {
            if (id) {
                this.loadingNum++;
            } else {
                this.treeLoading = true;
                this.loadingNum++;
            }
            cmofferApi.goodsCategory({}, "get", id ? id : "").then((res) => {
                this.treeLoading = false;
                if (res) {
                    if (id) {
                        this.addForm = res.data;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(id);
                        });
                    } else {
                        this.treeData = res.data;
                        this.defaultExpandedKeys = [this.treeData[0].id];
                        if (!this.addForm.id) {
                            this.$nextTick(() => {
                                this.$refs.myTree.$refs.tree.setCurrentKey(
                                    res.data[0].id
                                );
                            });
                            this.nowClick = res.data[0];
                            this.goodsCategory(res.data[0].id);
                        }
                    }
                }
                this.treeLoading = false;
                this.loadingNum--;
            });
        },
        /**
         * 分类树
         */
        goodsCategorySelect() {
            cmofferApi.goodsCategorySelect({}, "get").then((res) => {
                if (res) {
                    this.cascaderTreeData = res.data;
                }
            });
        },
        handleAddTreeNode() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                name: "",
                name_en: "",
                id: "",
                parent_id: this.nowClick.id,
                sort: 0,
                code: "",
            };
            this.nowStatus = 1;
            //   this.nowClick = null
        },
        // 节点点击
        handleTreeNodeClick(sth) {
            console.log("sth: ", sth.id);
            this.goodsCategory(sth.id);
            this.goodsCategorySelect();
            this.nowStatus = 0;
            this.nowClick = sth;
        },
        // 新增和修改提交
        commit() {
            console.log(this.nowStatus);
            if (this.nowStatus == 0) {
                this.addForm.id = this.nowClick.id;
            }
            if (typeof this.addForm.parent_id !== "number") {
                this.addForm.parent_id =
                    this.addForm.parent_id[this.addForm.parent_id.length - 1];
            }
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .goodsCategory(
                            { ...this.addForm },
                            // this.nowStatus == 0 ? "put" : "post",
                            "post",
                            this.addForm.id ? this.addForm.id : ""
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.nowStatus == 0
                                        ? "Edit Success"
                                        : "Add Success"
                                );
                                this.goodsCategory();
                                this.defaultExpandedKeys = [this.addForm.id];
                                this.goodsCategory(this.addForm.id);
                            }
                        });
                }
            });
        },
        //删除提交
        del() {
            this.$confirm("Do you want to continue?", "Tip", {
                type: "warning",
            })
                .then(() => {
                    this.loadingNum++;
                    cmofferApi
                        .goodsCategory({}, "delete", this.nowClick.id)
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "删除成功"
                                        : "Delete Success"
                                );
                                this.goodsCategory();
                            } else {
                                this.$message.error(res.errmsg);
                            }
                            this.loadingNum--;
                        });
                })
                .catch(() => {
                    // this.loadingNum--;
                    this.$message.info("Cancelled");
                });
        },
        /**
         * 清空
         */
        clear() {
            this.addForm.name = "";
            this.addForm.name_en = "";
            this.addForm.sort = 0;
            this.addForm.code = "";
        },
        /**
         * 从tree组件中接收拖拽函数
         */
        allowDrop(params) {
            console.log('dropType: ', params.dropType);
            console.log('draggingNode: ', params.draggingNode.data);
            console.log('dropNode: ',params.dropNode.data);
            // return false;
            if (params.dropType == "inner") {
                this.loadingNum++;
                this.addForm = params.draggingNode.data;
                this.addForm.parent_id = params.dropNode.data.id;
                cmofferApi
                    .goodsCategory({ ...this.addForm }, "post", this.addForm.id)
                    .then((res) => {
                        if (res) {
                            this.$message.success(
                                this.$i18n.locale == "zh"
                                    ? "编辑成功"
                                    : "Edit Success"
                            );
                            this.defaultExpandedKeys = [this.addForm.id];
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id
                            );
                        }
                        this.loadingNum--;
                    });
            } else if (params.dropType == "before") {
                this.loadingNum++;
                this.addForm = params.draggingNode.data;
                this.addForm.parent_id = params.dropNode.data.pid;
                this.addForm.sort = params.dropNode.data.sort - 1;
                cmofferApi
                    .goodsCategory({ ...this.addForm }, "post", this.addForm.id)
                    .then((res) => {
                        if (res) {
                            this.$message.success(
                                this.$i18n.locale == "zh"
                                    ? "编辑成功"
                                    : "Edit Success"
                            );
                            this.defaultExpandedKeys = [this.addForm.id];
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id
                            );
                            this.goodsCategory();
                        }
                        this.loadingNum--;
                    });
            } else if (params.dropType == "after") {
                this.loadingNum++;
                this.addForm = params.draggingNode.data;
                this.addForm.parent_id = params.dropNode.data.pid;
                this.addForm.sort = params.dropNode.data.sort + 1;
                cmofferApi
                    .goodsCategory({ ...this.addForm }, "post", this.addForm.id)
                    .then((res) => {
                        if (res) {
                            this.$message.success(
                                this.$i18n.locale == "zh"
                                    ? "编辑成功"
                                    : "Edit Success"
                            );
                            this.defaultExpandedKeys = [this.addForm.id];
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id
                            );
                            this.goodsCategory();
                        }
                        this.loadingNum--;
                    });
            }
        },
    },
    created() {
        this.goodsCategory();
        this.goodsCategorySelect();
    },
    computed: {
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.goodsClassification {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        box-sizing: border-box;
        height: calc(100% - 10px);
        border: 1px solid #eee;
        &:hover {
            box-shadow: 2px 2px 10px #eee;
        }
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        // border-left: 1px #ddd solid;

        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content,
        .el-input {
            width: 500px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409eff;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
        .prompt {
            color: red;
            font-size: 8px;
            text-align: left;
        }
        .is-disabled {
            .el-input__inner,
            .el-textarea__inner {
                color: #333 !important;
                background: #fff;
                &:hover {
                    border-color: $color-primary;
                }
            }
        }
    }
}
</style>
